/**
 * A tela apresentada, no palco: ocupa o palco inteiro (sem cortar) e a câmera do outro lado (`camera`) vira uma miniatura no
 * canto. Vale para a tela do outro lado e para a de quem apresenta, como no Google Meet: quem compartilha a tela toda vê o
 * espelho infinito, e é o esperado. O aviso de quem está apresentando (com o atalho para parar) fica na `RoomStatusStack`.
 * Numa sala com várias pessoas a miniatura é uma só (a de quem apresenta) e `moreCount` acrescenta "+N" para as demais.
 */
import { isTrackReference, VideoTrack } from '@livekit/components-react';
import { cn } from '@/lib/utils';
import { RemoteTile } from './ParticipantTile';

/** A tela apresentada (de qualquer lado) ocupa o palco; a câmera do outro lado (`camera`) vira miniatura. */
export function SharedScreen({ trackRef, camera, moreCount = 0, thumbClassName, thumbPosition }) {
    return (
        <div data-screen-share="" className="absolute inset-0 overflow-hidden rounded-[inherit] bg-black">
            {isTrackReference(trackRef) && (
                <VideoTrack trackRef={trackRef} data-screen-share-video="" className="absolute inset-0 h-full w-full object-contain" />
            )}
            {camera && (
                <div className={cn('absolute z-10 aspect-video overflow-hidden rounded-xl border border-white/20 shadow-lg', thumbClassName, thumbPosition)}>
                    <RemoteTile trackRef={camera} size="sm" />
                    {moreCount > 0 && (
                        <span
                            data-screen-share-more=""
                            role="img"
                            aria-label={moreCount === 1 ? 'Mais 1 pessoa na chamada' : `Mais ${moreCount} pessoas na chamada`}
                            className="absolute right-1 top-1 rounded-full bg-black/70 px-1.5 text-[11px] font-semibold text-white"
                        >
                            {`+${moreCount}`}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
}
